var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaison = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.01 2.871a.455.455 0 0 0-.29.108L6.942 7.16 2.178 11.34a.438.438 0 0 0 .288.771h2.484v7.167c0 1.065.696 1.902 1.587 1.902H17.5c.875 0 1.586-.855 1.586-1.902 0-.054 0-5.54-.014-7.16l2.51-.007a.438.438 0 0 0 .292-.77l-4.783-4.183-4.79-4.179a.443.443 0 0 0-.291-.108m0 .438l4.794 4.18 4.779 4.184h-2.511a.44.44 0 0 0-.438.447c.012 1.638.012 7.158.012 7.158 0 .807-.52 1.461-1.146 1.461H6.536c-.64 0-1.146-.654-1.146-1.46 0 0 0-5.52.015-7.159a.456.456 0 0 0-.456-.447H2.465l4.767-4.185L12.01 3.31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.822 20.737h4.392v-1.875c0-1.434-1.011-2.643-2.205-2.643-1.185 0-2.187 1.209-2.187 2.643v1.875zm4.833.438H9.384v-2.313c0-1.674 1.2-3.084 2.625-3.084 1.458 0 2.646 1.383 2.646 3.084v2.313z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaison);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maison.1a4211ea652b32e427e2bbd13f5e2a24.svg";